<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="350"
      size="mini"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('form_title_reportDoc') || '出差报告文档' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openReportDocUpload()"
              v-if="allow('A')"
              v-show="tripReimbursementReportCode && !disabled"
            >
              <b-icon-upload></b-icon-upload>
              {{ $l('INDEX.btn_upload') || '上传' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:showFiles="{ row }">
        <span>
          {{ row.v_docFileType }}
        </span>
        <br />
        <span>
          {{ row.fileName }}
        </span>
        <br />
        <span>
          {{ row.docRemark }}
        </span>
      </template>
      <template v-slot:fileStatus="{row}">
        <el-tag
          size="mini"
          :type="
            row.fileStatus === 'Y'
              ? 'primary'
              : row.fileStatus === 'N'
              ? 'warning'
              : 'info'
          "
        >
          {{ row.v_fileStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="allow('M')"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openReportDocEdit(row.tripReimbursementReportDocCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.fileStatus === 'Y' && !disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.tripReimbursementReportDocCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>

    <ReportDocUpload
      :title="$l('dialog_title_upload_reportDoc') || '上传出差报告文档'"
      :visible.sync="reportDocUploadVisible"
      :tripReimbursementCode="tripReimbursementCode"
      :tripReimbursementItemCode="tripReimbursementItemCode"
      :tripReimbursementReportCode="tripReimbursementReportCode"
      @reload="getData()"
    />

    <ReportDocEdit
      :title="$l('dialog_title_edit_reportDoc') || '编辑出差报告文档'"
      :visible.sync="reportDocEditOption.visible"
      :tripReimbursementReportDocCode="reportDocEditOption.code"
      @reload="getData()"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import ReportDocUpload from '../report-doc-upload/dialog'
import ReportDocEdit from '../report-doc-edit/dialog'
export default {
  mixins: [EditLoading],
  components: {ReportDocUpload, ReportDocEdit},
  props: {
    disabled: {type: Boolean, default: false},
    tripReimbursementCode: {type: String, default: ''},
    tripReimbursementItemCode: {type: String, default: ''},
    tripReimbursementReportCode: {type: String, default: ''},
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
      },

      tableColumns: tableColumns(this),

      reportDocUploadVisible: false,
      reportDocEditOption: {
        visible: false,
        code: '',
      },
    }
  },
  watch: {
    tripReimbursementReportCode() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (
        !this.tripReimbursementCode ||
        !this.tripReimbursementItemCode ||
        !this.tripReimbursementReportCode
      )
        return
      this.loading = true
      this.$api
        .userTripReimbursementReportDocListApi({
          tripReimbursementCode: this.tripReimbursementCode,
          tripReimbursementItemCode: this.tripReimbursementItemCode,
          tripReimbursementReportCode: this.tripReimbursementReportCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .userTripReimbursementReportDocDelApi({
            tripReimbursementReportDocCode: code,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
          })
      })
    },
    downloadFile({fileCode = ''}) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    openReportDocUpload() {
      this.reportDocUploadVisible = true
    },
    openReportDocEdit(code) {
      this.reportDocEditOption = {
        visible: true,
        code,
      }
    },
  },
}
</script>
